(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button-analyze"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const analyzeButtons = document.querySelectorAll('.color-analysis-trigger');
  
  analyzeButtons.forEach(button => {
    // Apply hover effect based on setting
    const hoverEffect = button.closest('[data-block-id]')?.dataset.hoverEffect || 'brightness';
    button.setAttribute('data-hover-effect', hoverEffect);
    
    // Ensure the button has the proper class for our event handling
    if (!button.classList.contains('color-analysis-trigger')) {
      button.classList.add('color-analysis-trigger');
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
